import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Chatbot from './Chatbot';

export default function Layout({ children }) {
  return (
    <div className="sbb-app-layout">
      <Header />
      <main className="sbb-main-content">
        {children}
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}
